// import React from "react";
// import CankayaSidebar from "../Sidebar/CankayaSidebar";
// import CankayaOtherServices from "../ServiceAreas/CankayaServiceArea";
// import BadgeSection from "../../BadgeSection";
// import LeftSidebar from "../../Sidebars/LeftSidebar";

// const CankayaIntro = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
    
//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
//         ÇANKAYA HALI VE KOLTUK YIKAMA
//       </h1>

//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        

//         {/* İçerik */}
//         <div className="order-1 md:order-2 md:col-span-2 space-y-6">
//           <p>
//             Çankaya’nın yoğun yaşam temposunda ev temizliği büyük önem
//             taşır.Abone Halı Yıkama olarak, **hijyenik, kaliteli ve profesyonel
//             halı-koltuk yıkama hizmeti** sunarak Çankaya sakinlerine güvenilir
//             çözümler sağlıyoruz!
//           </p>

//           <p>
//             Özellikle **Bahçelievler, Ayrancı, Dikmen, Oran, Yıldız** gibi
//             semtlerde mobil servisimiz sayesinde **yerinden alım ve teslimat
//             hizmeti** sunuyoruz. Yoğun iş temposu nedeniyle zaman sıkıntısı
//             çeken müşterilerimiz için **hızlı ve etkili** temizlik çözümleri
//             sağlıyoruz.
//           </p>

//           <h2 className="text-lg font-semibold text-[#003132]">
//             Çankaya'da NedenAbone Halı Yıkama?
//           </h2>
//           <ul className="list-disc list-inside">
//             <li>
//               **Antibakteriyel ve hijyen garantili temizlik** – Sağlıklı yaşam
//               için profesyonel hijyen çözümleri
//             </li>
//             <li>
//               **Leke çıkarma garantisi** – En zorlu lekeler bile özel
//               yöntemlerle temizlenir
//             </li>
//             <li>
//               **Özel buhar ve vakum sistemleri** – Derinlemesine hijyen sağlamak
//               için etkili çözümler
//             </li>
//             <li>
//               **Halı ve koltuk kumaşına zarar vermeyen temizleme teknikleri**
//             </li>
//             <li>
//               **Evinizden alıp, profesyonel ortamda temizleyerek zamanında
//               teslim ediyoruz**
//             </li>
//             <li>
//               **Bahçelievler, Ayrancı, Dikmen, Oran gibi semtlere hızlı servis**
//             </li>
//           </ul>

//           <p>
//             **Çankaya’da hijyenik temizlik garantisiyle hizmet veriyoruz!**
//             Buhar, vakum ve özel temizlik şampuanlarıyla yapılan işlemler,
//             **kirleri ve alerjenleri yok ederken kumaş dokusuna zarar vermez**.
//           </p>

//           <p>
//             **Ev tekstili yıkama hizmetleri:** Yorgan, perde, battaniye gibi
//             ürünleri **antibakteriyel yıkama** ile temizleyerek evinizde
//             sağlıklı bir atmosfer oluşturuyoruz.
//           </p>

//           <p>
//             **Çankaya'nın her bölgesine ulaşan mobil hizmetimizle, zahmetsiz
//             temizlik çözümleri sağlıyoruz!** Hemen <strong>İletişim</strong>{" "}
//             sayfamızdan bize ulaşarak sipariş verebilir veya fiyat bilgisi
//             alabilirsiniz!
//           </p>
//           <CankayaSidebar />
//           <CankayaOtherServices />
       
//         </div>
//         {/* Sol Sidebar */}
//         <div className="order-2 md:order-1 space-y-6">
//           <LeftSidebar />
//         </div>

//         {/* Rozetler */}
//             <div className="order-3 md:order-3 space-y-6">
//           <BadgeSection />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CankayaIntro;
import React from "react";
import CankayaSidebar from "../Sidebar/CankayaSidebar";
import CankayaOtherServices from "../ServiceAreas/CankayaServiceArea";
import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";

const CankayaIntro = () => {
  return (
   <section className="relative overflow-hidden mt-[-95px] bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] pt-0 px-4 pb-12">
      <div className="relative max-w-screen-xl mx-auto">
        <div className="mb-8 text-center pt-8">
          <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/90 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
            Çankaya Halı Yıkama Hizmeti
          </span>

          <h1 className="mt-5 text-3xl md:text-5xl font-extrabold tracking-tight text-[#1f160f]">
            Çankaya Halı Yıkama ve Koltuk Yıkama
          </h1>

          <p className="mx-auto mt-5 max-w-4xl text-base md:text-lg leading-8 text-gray-700">
            <strong>Çankaya halı yıkama</strong> hizmetinde Abone Halı Yıkama;
            hijyenik temizlik, yerinden alım, zamanında teslim ve profesyonel
            koltuk yıkama çözümleri sunar. Bahçelievler, Ayrancı, Dikmen, Oran,
            Yıldız, Balgat, Çukurambar, Çayyolu, Yaşamkent ve Bilkent
            bölgelerinde hizmet veriyoruz.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="tel:05015336066"
              className="rounded-full bg-[#2f160b] px-7 py-3 text-sm font-bold text-[#f8e6b2] shadow-lg hover:scale-105 transition"
            >
              Hemen Ara (0501 533 60 66)
            </a>

            <a
              href="https://wa.me/905015336066"
              className="rounded-full bg-green-600 px-7 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition"
            >
              WhatsApp Teklif Al
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">
          <aside className="order-2 lg:order-1 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <LeftSidebar />
            </div>
          </aside>

          <main className="order-1 lg:order-2 lg:col-span-6">
            <article className="rounded-[30px] border border-[#ead9b7] bg-white/95 p-6 md:p-8 shadow-[0_25px_70px_rgba(15,23,42,0.10)]">
              <div className="space-y-5 text-[16px] leading-8 text-gray-700 text-justify">
                <h2 className="text-2xl md:text-3xl font-bold text-[#1f160f] text-left">
                  Çankaya’da Profesyonel Halı Yıkama
                </h2>

                <p>
                  Abone Halı Yıkama, Çankaya bölgesinde halı ve koltuk yıkama
                  hizmetlerinde hijyen odaklı, güvenilir ve profesyonel çözümler
                  sunar. Halılarınız evinizden teslim alınır, halı türüne göre
                  uygun yöntemle yıkanır, durulanır, kurutulur ve hijyenik şekilde
                  paketlenerek teslim edilir.
                </p>

                <p>
                  Çankaya’nın yoğun yaşam temposunda temizlik için zaman ayırmak
                  zor olabilir. Bu nedenle yerinden alım ve teslimat hizmetimizle
                  Bahçelievler, Ayrancı, Dikmen, Oran, Yıldız ve çevresinde hızlı
                  servis sağlıyoruz.
                </p>

                <div className="my-7 rounded-2xl border border-emerald-100 bg-emerald-50/80 p-5">
                  <h3 className="text-xl font-bold text-[#0f3d2e] mb-4">
                    Neden Abone Halı Yıkama?
                  </h3>

                  <ul className="grid gap-3 text-left">
                    <li>✓ Çankaya genelinde yerinden alım ve teslimat</li>
                    <li>✓ Halı, koltuk, perde, yorgan ve battaniyede tam çözüm</li>
                    <li>✓ Antibakteriyel ve hijyen odaklı temizlik</li>
                    <li>✓ Leke, koku, toz ve alerjenlere karşı detaylı yıkama</li>
                    <li>✓ Kumaşa ve halı dokusuna zarar vermeyen yöntemler</li>
                    <li>✓ Zamanında teslim ve güvenli paketleme</li>
                  </ul>
                </div>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Çankaya Koltuk Yıkama Hizmeti
                </h2>

                <p>
                  Koltuk yıkama işleminde kumaş yapısına uygun temizlik ürünleri,
                  buhar destekli sistemler ve güçlü vakum makineleri kullanılır.
                  Günlük kullanımda oluşan kir, leke, kötü koku, toz ve alerjenler
                  kumaşa zarar vermeden temizlenir.
                </p>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Çankaya’da Hizmet Verdiğimiz Bölgeler
                </h2>

                <p>
                  Bahçelievler, Ayrancı, Dikmen, Oran, Yıldız, Balgat,
                  Çukurambar, Çayyolu, Yaşamkent, Beytepe, Beysukent ve Bilkent
                  başta olmak üzere Çankaya’nın birçok bölgesinde halı yıkama ve
                  koltuk yıkama hizmeti veriyoruz.
                </p>

                <div className="rounded-2xl bg-[#fff7df] border border-[#ead9b7] p-5">
                  <h3 className="text-xl font-bold text-[#2b160b] mb-3">
                    Çankaya Halı Yıkama Fiyatları
                  </h3>
                  <p>
                    Çankaya halı yıkama fiyatları; halının türüne, ölçüsüne,
                    leke durumuna ve talep edilen ek hizmetlere göre değişebilir.
                    Net fiyat bilgisi için bizi arayabilir veya WhatsApp
                    üzerinden ölçü ve hizmet talebinizi iletebilirsiniz.
                  </p>
                </div>

                <p>
                  Abone Halı Yıkama olarak amacımız yalnızca halılarınızı
                  temizlemek değil; evinizde daha hijyenik, ferah ve sağlıklı bir
                  ortam oluşturmaktır. Çankaya halı yıkama ve koltuk yıkama
                  hizmetleri için hemen iletişime geçebilirsiniz.
                </p>
              </div>

              <div className="mt-8 space-y-6">
                <CankayaSidebar />
                <CankayaOtherServices />
              </div>
            </article>
          </main>

          <aside className="order-3 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <BadgeSection />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default CankayaIntro;